'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import HtzLink from '@haaretz/s-htz-link';
import useBi from '@haaretz/s-use-bi';
export default function SectionHeadLinkClient({ href, children }) {
    const biAction = useBi();
    return /*#__PURE__*/ _jsx(HtzLink, {
        onClick: ()=>{
            biAction({
                action_id: 153,
                feature: 'content list',
                feature_type: 'Content',
                campaign_name: children ?? ''
            });
        },
        href: href,
        children: children
    });
}

//# sourceMappingURL=SectionHeadLink.client.js.map